import { Component, OnInit } from "@angular/core";
import { MedicalServiceWizardService } from "../../../services/wizard/medical-service/medical-service-wizard";

@Component({
  selector: 'medical-service-clinic-history-component',
  templateUrl: './medical-service-clinic-history.component.html',
  styleUrls: ['./medical-service-clinic-history.component.css']
})
export class MedicalServiceClinicHistoryComponent implements OnInit {

  patientId: number;

  constructor(private medicalServiceWizardService: MedicalServiceWizardService) {
    this.patientId = this.medicalServiceWizardService.medicalServiceSearchItem.PatientId;
  }

  ngOnInit()  {

  }

}
